import theme, { rem } from '@gameday/react-components/utils/theme'
import styled, { css } from 'styled-components'

import Product from './product'

const StyledProduct = styled.div`
  .MuiListItem-root {
    .MuiCheckbox-colorPrimary.Mui-checked {
      color: var(--custom-primary-color) !important;
    }
  }
`

const StyledProductWrapper = styled.div`
  > h3 {
    font-size: ${theme.typography.fontSizeSm};
    font-weight: ${theme.typography.fontWeightBold};
    color: ${`var(--gameday-body-textColorDark, ${theme.body.textColorDark})`};
  }

  & + & {
    margin-top: ${rem(10)};
  }

  ${props =>
    props.isGroup &&
    css`
      border: ${theme.borders.default};
      border-radius: 4px;
      padding: ${rem(22)} ${rem(20)} ${rem(20)} ${rem(20)};
      background-color: ${`var(--gameday-body-background, ${theme.body.background})`};
    `}
`

const StyledGroupDescription = styled.div`
  font-size: ${theme.typography.fontSizeSm};
  color: ${`var(--gameday-body-textColorLight, ${theme.body.textColorLight})`};
  margin: 0 0 ${rem(10)};

  ${props =>
    props.isError &&
    css`
      color: ${theme.status.errorColor};
    `}
`

const ProductsList = ({
  pg,
  psProduct,
  paidMap,
  formType,
  onProductChange,
  childProductList,
  errors,
  errorText = {},
  errorType,
  touched,
  values,
  pgMinimumFulfilled,
  pgMaximumFulfilled,
  productsInGroup,
  paymentGateway,
  feeConfigurations,
  formData,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  pgSelectedPlusPaid,
  displayPriceAsZero = false,
}) => {
  const RenderGroupHeader = () => {
    const isMinMaxEqual = pg.minimumProductCount === pg.maximumProductCount
    const isMinZero = !Number(pg.minimumProductCount)
    const isMaxZero = !Number(pg.maximumProductCount)
    const isPgFulfilledAndMinMaxEqual = isMinMaxEqual && !pgMinimumFulfilled[pg.id] && !pgMaximumFulfilled[pg.id]

    return (
      <div>
        {pg.productGroupName ? <h3>{pg.productGroupName}</h3> : null}
        {pg.productGroupDescription ? (
          <StyledGroupDescription>{pg.productGroupDescription}</StyledGroupDescription>
        ) : null}
        {!isMinZero && !pgMinimumFulfilled[pg.id] && !isPgFulfilledAndMinMaxEqual && (
          <StyledGroupDescription isError>
            {`You must pick at least ${pg.minimumProductCount} product${
              pg.minimumProductCount > 1 ? 's' : ''
            } within this product group before you can continue.`}
          </StyledGroupDescription>
        )}
        {!isMaxZero && !pgMaximumFulfilled[pg.id] && (
          <StyledGroupDescription isError>
            {`You must pick at most ${pg.maximumProductCount} product${
              pg.maximumProductCount > 1 ? 's' : ''
            } within this product group before you can continue.`}
          </StyledGroupDescription>
        )}
      </div>
    )
  }

  return (
    <StyledProductWrapper isGroup={!!pg.productGroupName} key={pg.id}>
      {pg.productGroupName && RenderGroupHeader()}
      <StyledProduct>
        {(productsInGroup || []).map(p => {
          const identifier = p.sfid
          return (
            <Product
              key={identifier}
              {...p}
              identifier={identifier}
              formType={formType}
              onChange={(key, value) => {
                onProductChange(key, value)
              }}
              value={values[identifier]}
              error={touched[identifier] && errors[identifier]}
              errorType={errorType[identifier]}
              errorText={errorText[identifier]}
              values={values}
              paidProducts={paidMap}
              childProducts={childProductList[identifier]}
              preselectedProduct={psProduct}
              feeConfigurations={feeConfigurations}
              paymentGateway={paymentGateway}
              formData={formData}
              displayPriceAsZero={displayPriceAsZero}
            />
          )
        })}
      </StyledProduct>
    </StyledProductWrapper>
  )
}

export default ProductsList
